export default __webpack_public_path__ + "static/media/a023-startup2-en-short.0d7e7b5f.png";